// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1wsCs","info":"Note_info__RRjlr","note":"Note_note__2T6n-","actions":"Note_actions__358RY"};